import { render, staticRenderFns } from "./BrandEdit.vue?vue&type=template&id=a1b90a7a"
import script from "./BrandEdit.vue?vue&type=script&lang=js"
export * from "./BrandEdit.vue?vue&type=script&lang=js"
import style0 from "./BrandEdit.vue?vue&type=style&index=0&id=a1b90a7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports